// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__6e0Ju","container":"Spinner_container__4hsxq"};